const IdentityInfo = require('../services/identity-info');

class HttpProxy {
  /* eslint-disable no-unused-expressions */
  static async request(url, options) {
    const token = IdentityInfo.getIdToken();
    const session = await IdentityInfo.getIdentitySession();

    const {
      userUuid,
      containerUuid,
      roleUuid,
      productUuid
    } = session;

    let headers = {
      Authorization: `Bearer ${token}`
    };

    productUuid && (headers.XbsProductUuid = productUuid);
    userUuid && (headers.XbsUserUuid = userUuid);
    containerUuid && (headers.XbsContainerUuid = containerUuid);
    roleUuid && (headers.XbsRoleUuid = roleUuid);

    options.headers = { ...options.headers, ...headers };
    const response = await fetch(url, options);
    if (response.ok) {
      return response;
    } else {
      const error = await response.json();
      throw error;
    }
  }

}

module.exports = HttpProxy;
